import jwt_decode from 'jwt-decode'

class Auth {
    config

    constructor(config) {
        this.config = config
    }

    login = async (data, token, headers = {}) => {
        const response = await fetch(this.config.get('api') + '/auth', {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                ...(token && { Authorization: `Bearer ${token}` }),
                ...headers,
            },
            body: JSON.stringify(data),
        })

        const json = await response.json()

        if (response.ok) {
            this.setSession(json)
        } else {
            throw new Error(json.message || 'Failed to login')
        }
    }

    refresh = async () => {
        const response = await fetch(this.config.get('api') + '/token/refresh', {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
            },
            body: JSON.stringify({
                refresh_token: this.getRefeshToken(),
            }),
        })

        const json = await response.json()

        if (response.ok) {
            this.setSession(json)
        } else {
            this.logout()
            throw new Error(json.message || 'Failed to login')
        }
    }

    logout() {
        return new Promise<void>(resolve => {
            localStorage.removeItem('token')
            localStorage.removeItem('claims')
            localStorage.removeItem('expires_at')
            localStorage.removeItem('refresh_token')
            resolve()
        })
    }

    setSession = result => {
        const claims = jwt_decode(result.token)

        localStorage.setItem('token', result.token)
        localStorage.setItem('claims', JSON.stringify(claims))
        localStorage.setItem('expires_at', claims.exp)
        localStorage.setItem('refresh_token', result.refresh_token)
    }

    getRefeshToken() {
        return localStorage.getItem('refresh_token')
    }

    getToken() {
        return localStorage.getItem('token')
    }

    getProfile() {
        const claims = localStorage.getItem('claims')
        return claims ? JSON.parse(claims) : {}
    }

    isAuthenticated() {
        return !!this.getToken()
    }
}

export default Auth
